(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.koaGalleryReady === 'true') return;

    const media = [...gallery.querySelectorAll('[data-gallery-media]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const thumbsTrack = gallery.querySelector('[data-product-thumbnails]');
    if (!media.length) return;

    gallery.dataset.koaGalleryReady = 'true';

    const activate = (index, scrollThumb = true) => {
      const safeIndex = Math.max(0, Math.min(Number(index) || 0, media.length - 1));

      media.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === safeIndex);
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === safeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (scrollThumb && thumbsTrack && thumbs[safeIndex]) {
        const thumb = thumbs[safeIndex];
        const targetLeft = thumb.offsetLeft - (thumbsTrack.clientWidth - thumb.offsetWidth) / 2;
        thumbsTrack.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activate(index));
    });

    const productRoot = gallery.closest('[data-product-root]');
    const variantSelect = productRoot?.querySelector('[data-variant-select]');

    variantSelect?.addEventListener('change', () => {
      const mediaId = variantSelect.selectedOptions[0]?.dataset.featuredMediaId;
      if (!mediaId) return;

      const nextIndex = media.findIndex((item) => item.dataset.mediaId === mediaId);
      if (nextIndex >= 0) activate(nextIndex);
    });

    const initialIndex = media.findIndex((item) => item.classList.contains('is-active'));
    activate(initialIndex >= 0 ? initialIndex : 0, false);
  };

  const initSizePicker = (root) => {
    if (!root || root.dataset.koaSizePickerReady === 'true') return;

    const select = root.querySelector('[data-variant-select]');
    const buttons = [...root.querySelectorAll('[data-size-button]')];
    const selectedSize = root.querySelector('[data-selected-size]');
    if (!select || !buttons.length) return;

    root.dataset.koaSizePickerReady = 'true';

    const sync = () => {
      let activeButton = null;
      buttons.forEach((button) => {
        const active = button.dataset.variantId === select.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) activeButton = button;
      });
      if (selectedSize && activeButton) selectedSize.textContent = activeButton.dataset.sizeLabel || activeButton.textContent.trim();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = button.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
    });

    select.addEventListener('change', sync);
    sync();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product-root]').forEach(initSizePicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
